import { render, staticRenderFns } from "./EightCentres.vue?vue&type=template&id=0ca8cb78&"
import script from "./EightCentres.vue?vue&type=script&lang=js&"
export * from "./EightCentres.vue?vue&type=script&lang=js&"
import style0 from "./EightCentres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports